var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EFF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9502 11.5557H11.9502C11.4198 11.5557 10.9111 11.7664 10.536 12.1415C10.1609 12.5165 9.9502 13.0252 9.9502 13.5557V25.5557C9.9502 26.0861 10.1609 26.5948 10.536 26.9699C10.9111 27.3449 11.4198 27.5557 11.9502 27.5557H27.9502C28.4806 27.5557 28.9893 27.3449 29.3644 26.9699C29.7395 26.5948 29.9502 26.0861 29.9502 25.5557V13.5557C29.9502 13.0252 29.7395 12.5165 29.3644 12.1415C28.9893 11.7664 28.4806 11.5557 27.9502 11.5557ZM27.9502 18.5557H11.9502V15.5557H27.9502V18.5557Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.112dd3ec34f25cf23c679f02e8a94ba1.svg";
export { ForwardRef as ReactComponent };